import { useState, useRef, useEffect } from "react";
import TextWithTooltip from "./TextWithTooltip";

const numberRanges = [
  { min: 1, max: 10 },
  { min: 11, max: 20 },
  { min: 21, max: 50 },
  { min: 51, max: 100 },
  { min: 101, max: 200 },
  { min: 201, max: 500 },
  { min: 501, max: 1000 },
  { min: 1001, max: 5000 },
  { min: 5001, max: 10000 },
  { min: 10001, max: null },
];

function NumberRangeDropdown({ selectedValues, setSelectedValues, placeholder }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // helper to turn object into string like "1,10"
  const rangeToString = (range) => (range.max ? `${range.min},${range.max}` : `${range.min},`);
  const stringToLabel = (str) => {
    const [min, max] = str.split(",");
    return max ? `${min}-${max}` : `${min}+`;
  };

  const handleToggleOption = (range) => {
    const rangeStr = rangeToString(range);
    if (selectedValues.includes(rangeStr)) {
      setSelectedValues(selectedValues.filter((val) => val !== rangeStr));
    } else {
      setSelectedValues([...selectedValues, rangeStr]);
    }
  };

  const handleRemoveChip = (rangeStr) => {
    setSelectedValues(selectedValues.filter((val) => val !== rangeStr));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="checkbox-chips-dropdown-container"
      ref={dropdownRef}
      onClick={(e) => {
        e.stopPropagation();
        setIsOpen((prev) => !prev);
      }}
      style={{ position: "relative" }}
    >
      {selectedValues.map((val) => (
        <div key={val} className="chip_gcsf gray">
          
          <TextWithTooltip className="chip-label" text={stringToLabel(val)}/>
          <button
            className="chip-close"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveChip(val);
            }}
          >
            &times;
          </button>
        </div>
      ))}

      <input
        type="text"
        placeholder={selectedValues.length === 0 ? placeholder : ""}
        readOnly
        style={{
          flex: 1,
          border: "none",
          outline: "none",
          minWidth: "50px",
          paddingRight: "1.5rem",
          fontSize: "12.8px",
          color:"#606A74"
        }}
      />

      {/* Chevron */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
        style={{
          position: "absolute",
          right: "0.25rem",
          top: "50%",
          transform: isOpen
            ? "translateY(-50%) rotate(180deg)"
            : "translateY(-50%)",
          transition: "transform 0.2s ease",
          pointerEvents: "none",
        }}
      >
        <path d="M6 9l6 6 6-6"></path>
      </svg>

      {/* Dropdown */}
      {isOpen && (
        <div
          className="dropdown-list"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #CEE0F3",
            borderRadius: "6px",
            marginTop: "4px",
            boxShadow: "0 4px 12px rgba(140, 149, 159, 0.15)",
            zIndex: 998,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {numberRanges.map((range) => {
            const rangeStr = rangeToString(range);
            return (
              <label
                key={rangeStr}
                className="dropdown-item-gdc"
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  checked={selectedValues.includes(rangeStr)}
                  onChange={() => handleToggleOption(range)}
                  style={{ marginRight: "10px" }}
                />
                {stringToLabel(rangeStr)}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default NumberRangeDropdown;
